/* eslint-disable complexity */
import {
  BookWidgetAem,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { RecentListItem } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';

export const prepareSearchModalRecentSearchList = (
  bookWidgetAem: BookWidgetAem | null,
  retrieveSearchDataList: RetrieveSearchData[] | null
): RecentListItem[] => {
  const recentSearchList: RecentListItem[] = [];

  if (retrieveSearchDataList?.length) {
    retrieveSearchDataList.forEach((recentSearch) => {
      const originAirport = recentSearch.airports[0].fromAirportcode;
      const destinationAirport =
        recentSearch.airports[recentSearch.airports.length - 1].toAirportcode;
      const toLabel = bookWidgetAem?.airportsField.searchModal.to || '';
      const departureDate = recentSearch.dates[0].departureDate;
      let returnDate =
        recentSearch.dates[recentSearch.dates.length - 1].returnDate;

      let label = `${originAirport} ${toLabel} ${destinationAirport}`;
      if (recentSearch.selectTripType === TripTypeOptions.MULTI_CITY) {
        const multiCityLabel = bookWidgetAem?.tripTypesField.multiCity || '';
        label = `${label} (${multiCityLabel})`;
        returnDate =
          recentSearch.dates[recentSearch.dates.length - 1].departureDate;
      }

      recentSearchList.push({
        label,
        departureDate,
        returnDate
      });
    });
  }

  return recentSearchList;
};
